import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  TextInput,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
} from "react-native";
import DefaultText from "../../../components/text/DefaultText";
import * as userNftActions from "../../../store/actions/userNft";
import Constants from "expo-constants";

const AddArtworkETHScreen = (props) => {
  if (__DEV__) {
    console.log("hi:", Constants.isDevice);
  }
  const [ethPublicKey, setEthPublicKey] = useState(
    // "0x1db2ebea736f8653e6b8d927801f7ed3eb8bf47c"
    __DEV__ ? "0x1db2ebea736f8653e6b8d927801f7ed3eb8bf47c" : ""
  );
  const [getPassWord, setPassWord] = useState("");
  const dispatch = useDispatch();

  const ethPublicKeyHandler = (enteredEthPublicKey) => {
    setEthPublicKey(enteredEthPublicKey);
  };

  const PassWordHandler = (enteredPassWord) => {
    setPassWord(enteredPassWord);
  };
  const dismissKeyboard = () => {
    if (Platform.OS != "web") {
      Keyboard.dismiss();
    }
  };

  return (
    //Keyboard Avoiding View?
    <View style={styles.screen}>
      <TouchableWithoutFeedback onPress={dismissKeyboard}>
        <TextInput
          placeholder={"ETH Public Key"}
          placeholderTextColor="white"
          onChangeText={ethPublicKeyHandler}
          value={ethPublicKey}
          style={styles.EmailContainer}
        />
      </TouchableWithoutFeedback>

      <View style={{ marginTop: "10%", width: "80%" }}>
        <TouchableOpacity
          style={styles.LoginContainer}
          onPress={() => {
            console.log(ethPublicKey);
            dispatch(
              userNftActions.addPublicKey(
                "ETHEREUM",
                ethPublicKey
                //"0x8e22b546b8684b1217308d03af8d51263d15e7c9"
                //"0x644a0884dc50d06b04cfcc2ad65949c6aa5e8cc4"
              )
            ); //FIXME Check async thunk
            props.navigation.navigate("ProfileUserScreen");
          }}
        >
          <Text
            style={{ color: "white", fontFamily: "JosefinSans_400Regular" }}
          >
            Import
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignSelf: "center",
    alignContent: "center",
    alignItems: "center",
  },
  EmailContainer: {
    color: "white",
    height: 42,
    width: "80%",
    borderBottomWidth: 1,
    fontFamily: "JosefinSans_400Regular",
    borderColor: "white",
  },
  PassWordContainer: {
    color: "white",
    height: 42,
    width: "80%",
    borderBottomWidth: 1,
    marginTop: "5%",
    fontFamily: "JosefinSans_400Regular",
    borderColor: "white",
  },
  LoginContainer: {
    borderWidth: 1,
    height: 48,
    width: 345,
    left: 2,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "black",
    alignSelf: "center",
    textAlign: "center",
    borderColor: "white",
  },
  ForgotPasswordContainer: {
    justifyContent: "center",
  },
});

export default AddArtworkETHScreen;
